import { useState, useCallback } from 'react';
import { useFetch } from './useFetch';
import { API_CONFIG } from '../config/api';

interface MaterialAccessState {
  hasAccess: boolean;
  isLoading: boolean;
  error: string | null;
}

export const useMaterialAccess = () => {
  const [state, setState] = useState<MaterialAccessState>({
    hasAccess: false,
    isLoading: false,
    error: null,
  });

  const { fetchWithAuth } = useFetch();

  const checkMaterialAccess = useCallback(async (materialId: string, isFree: boolean): Promise<boolean> => {
    // Se o material for gratuito, sempre tem acesso
    if (isFree) {
      setState(prev => ({
        ...prev,
        hasAccess: true,
        isLoading: false,
        error: null,
      }));
      return true;
    }

    setState(prev => ({
      ...prev,
      isLoading: true,
      error: null,
    }));

    try {
      const response = await fetchWithAuth(`${API_CONFIG.BASE_URL}/materials/my`);

      if (!response.ok) {
        throw new Error(`Erro ao buscar materiais: ${response.status}`);
      }

      const data = await response.json();
      const userMaterials = data.materials || [];
      
      // Verificar se o material está na lista de materiais do usuário
      const hasAccess = userMaterials.some((material: any) => 
        material.id === materialId
      );
      
      setState(prev => ({
        ...prev,
        hasAccess,
        isLoading: false,
      }));

      return hasAccess;
    } catch (error) {
      setState(prev => ({
        ...prev,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
        isLoading: false,
        hasAccess: false,
      }));
      return false;
    }
  }, [fetchWithAuth]);

  return {
    hasAccess: state.hasAccess,
    isLoading: state.isLoading,
    error: state.error,
    checkMaterialAccess,
  };
};
